import React from "react";
import moment from "moment-timezone";

import currencyFormatter from "../../../helpers/currencyFormatter";
import formatPaymentType from "../../../helpers/format-payment-type";

const INVOICE_TYPE_LABELS = {
  flightCharges: "Flight Charges",
  catering: "Catering",
  groundTransportation: "Ground Transportation",
  cancellationFee: "Cancellation Fee",
  refund: "Refund",
  creditCardProcessingFee: "Credit Card Processing Fee",
  other: "Other",
};

const formatDate = (date) => (date ? moment(date).format("M/D/YYYY") : "N/A");

const formatParens = (amount, isRefund = false) => {
  const value = (isRefund ? -1 : 1) * (amount || 0);
  const formatted = currencyFormatter.format(Math.abs(value));
  return value < 0 ? `(${formatted})` : formatted;
};

const sum = (items = [], key = "amount") =>
  items.reduce((acc, i) => acc + (i.typeLabel === "refund" ? -i[key] : i[key] || 0), 0);

const openNewTab = (path) =>
  window.open(path, "_blank", "noopener,noreferrer");

const InvoiceCard = ({ tripId, invoice, readOnly }) => {
  const details = invoice.invoiceDetails || [];
  const payments = invoice.paymentDetails || [];
  const invoiceTotal = sum(details);
  const paymentTotal = sum(payments);
  const balanceDue = invoiceTotal - paymentTotal;

  return (
    <div className="tv-invoice-card">
      <table className="tv-table tv-invoice-table">
        <thead>
        <tr>
          {!readOnly && (
            <th>
              <button
                type="button"
                className="base-button icon-button icon-button-small evo-blue"
                onClick={() => openNewTab(`/trips/${tripId}/invoices/${invoice._id}`)}
                title="Edit Invoice"
              >
                <span className="material-icons">edit</span>
              </button>
            </th>
          )}
          <th>Invoice Details</th>
          <th aria-label="Description"/>
          <th className="text-align-right">Amount</th>
        </tr>
        </thead>
        <tbody>
        {details.map((d, i) => (
          <tr key={d._id || i}>
            <td/>
            <td>{INVOICE_TYPE_LABELS[d.typeLabel] || d.typeLabel || "N/A"}</td>
            <td>{d.description}</td>
            <td className="text-align-right">{formatParens(d.amount, d.typeLabel === "refund")}</td>
          </tr>
        ))}
        </tbody>
        <tfoot>
        <tr>
          <td/>
          <td/>
          <td className="text-align-right tv-total-label">Total</td>
          <td className="text-align-right">{formatParens(invoiceTotal)}</td>
        </tr>
        </tfoot>
      </table>

      <table className="tv-table tv-invoice-table mt-2">
        <thead>
        <tr>
          <th/>
          <th>Payment Details</th>
          <th aria-label="Payment Type"/>
          <th className="text-align-right">Amount</th>
        </tr>
        </thead>
        <tbody>
        {payments.map((p, i) => (
          <tr key={p._id || i}>
            <td/>
            <td>{formatDate(p.date || p.paymentDate)}</td>
            <td>{formatPaymentType(p.typeLabel || p.paymentType)}</td>
            <td className="text-align-right">{formatParens(p.amount)}</td>
          </tr>
        ))}
        </tbody>
        <tfoot>
        <tr>
          <td/>
          <td/>
          <td className="text-align-right tv-total-label">Total</td>
          <td className="text-align-right">{formatParens(paymentTotal)}</td>
        </tr>
        <tr>
          <td/>
          <td/>
          <td className="text-align-right tv-total-label">Balance Due</td>
          <td
            className={`text-align-right ${
              balanceDue !== 0 ? "tv-text-danger" : ""
            }`}
          >
            {formatParens(balanceDue)}
          </td>
        </tr>
        </tfoot>
      </table>
    </div>
  );
};

const ClientInvoiceSummaryBlock = ({ tripId, trip, readOnly }) => {
  const invoices = trip?.invoiceData || [];

  return (
    <div className="tv-block tv-invoice-summary">
      <div className="tv-block-header">
        <h5 className="tv-block-title">Client Invoice Summary</h5>
      </div>

      <div className="tv-block-body">
        {invoices.length === 0 ? (
          <div className="tv-empty">No invoices are available.</div>
        ) : (
          invoices.map((invoice) => (
            <InvoiceCard key={invoice._id} tripId={tripId} invoice={invoice} readOnly={readOnly}/>
          ))
        )}
      </div>
    </div>
  );
};

export default ClientInvoiceSummaryBlock;
